import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useEvaluation } from './hooks';
import { EvaluationForm } from './Form';
import { StepsResolution886 } from '../../enums';
import ButtonDefault from '@/components/ui/ButtonDefault';
import { CardContent } from '@/components/views/Resolution886/CardContent';
import { ToastError } from '@/components/views/Resolution886/components/ToastError';

interface EvaluationStepProps {
	goToSubStep: (step: number) => void;
}

export function EvaluationStep({ goToSubStep }: Readonly<EvaluationStepProps>) {
	const { isLoading, assessmentsNotAvaliated, handleCheckEvaluation, handleUpdateStep } = useEvaluation({
		goToSubStep
	});

	return (
		<Row justify="center" align="middle" gutter={[16, 16]}>
			{assessmentsNotAvaliated && (
				<ToastError message={'Please identify the tasks and evaluate them before continuing'} />
			)}
			<Col span={24}>
				<CardContent>
					<EvaluationForm goToSubStep={goToSubStep} />
				</CardContent>
			</Col>
			<Col>
				<Row gutter={[16, 16]}>
					<Col>
						<ButtonDefault
							type="default"
							loading={isLoading}
							onClick={() => handleUpdateStep(StepsResolution886.GENERAL_INFORMATION)}
						>
							{I18n.get('Back')}
						</ButtonDefault>
					</Col>
					<Col>
						<ButtonDefault type="primary" loading={isLoading} onClick={handleCheckEvaluation}>
							{I18n.get('Next')}
						</ButtonDefault>
					</Col>
				</Row>
			</Col>
		</Row>
	);
}
